import React from 'react';
import { TextFrame } from '../types';

interface TextDisplayProps {
  textHistory: TextFrame[];
  latestText: string | null;
  isActive: boolean;
}

export const TextDisplay: React.FC<TextDisplayProps> = ({
  textHistory,
  latestText,
  isActive,
}) => {
  const formatConfidence = (confidence: number): string => {
    return `${(confidence * 100).toFixed(1)}%`;
  };

  const formatDuration = (durationMs: number): string => {
    return `${(durationMs / 1000).toFixed(1)}s`;
  };

  return (
    <div className="text-display">
      <div className="text-display-header">
        <h3>Live Transcription</h3>
        <div className={`status-indicator ${isActive ? 'active' : 'inactive'}`}>
          {isActive ? '🎤 Live' : '⏸️ Stopped'}
        </div>
      </div>

      {/* Current/Latest Text */}
      <div className="current-text">
        <div className="current-text-label">Current:</div>
        <div className={`current-text-content ${!latestText ? 'empty' : ''}`}>
          {latestText || 'No transcription yet...'}
        </div>
      </div>

      {/* Text History */}
      <div className="text-history">
        <div className="text-history-header">
          <span>History ({textHistory.length} entries)</span>
        </div>
        <div className="text-history-list">
          {textHistory.length === 0 ? (
            <div className="text-history-empty">
              No transcription history yet. Start streaming to see results.
            </div>
          ) : (
            textHistory
              .slice()
              .reverse()
              .map((frame, index) => (
                <div key={`${frame.transcribedAt}-${index}`} className="text-history-item">
                  <div className="text-content">{frame.text}</div>
                  <div className="text-metadata">
                    <span className="confidence">
                      Confidence: {formatConfidence(frame.confidence)}
                    </span>
                    <span className="language">
                      Lang: {frame.language}
                    </span>
                    <span className="duration">
                      Duration: {formatDuration(frame.audioDurationMs)}
                    </span>
                    <span className="timestamp">
                      {new Date(frame.transcribedAt).toLocaleTimeString()}
                    </span>
                    <span className={`final-status ${frame.isFinal ? 'final' : 'partial'}`}>
                      {frame.isFinal ? 'Final' : 'Partial'}
                    </span>
                  </div>
                </div>
              ))
          )}
        </div>
      </div>
    </div>
  );
};
